// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"442":"c9a5d344","540":"1cc6e303","787":"a3378524"}[chunkId] + ".chunk.js";
};